import { Input } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { REPORT_TABLE } from '../../shared/constants';

function DurationInput(props: GridRenderEditCellParams) {

	const { id, value, field } = props;

	const [currentVal, setCurrentVal] = useState(value || '');

	const apiRef = useGridApiContext();

	const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {

		if(!props.isEditable) {return;}

    const newValue = parseFloat(event.target.value); // The new value entered by the user

		if(newValue < 0 || newValue > 8) {return;}

		if(newValue === currentVal) {return;}

    apiRef.current.setEditCellValue({ id, field, value: newValue });

		if(Number.isNaN(newValue)) {
			setCurrentVal('');
			return;
		}

		setCurrentVal(newValue);
  };

	return (
		<Input
			id="duration"
			name='activityDuration'
			type='number'
			value={currentVal}
			multiline={false}
			disableUnderline
			inputProps={{
				min: REPORT_TABLE.ACTIVITY_DURATION_VALUES.MIN,
				max: REPORT_TABLE.ACTIVITY_DURATION_VALUES.MAX,
				step: REPORT_TABLE.ACTIVITY_DURATION_VALUES.STEP
			}}
			onChange={handleValueChange}
			onKeyDown={(e) => e.stopPropagation()}
		/>
	);
}

export default DurationInput;
